import {createContext, useContext} from "react";

export const SourcesContext = createContext({});

export function useSources() {
	const sources = useContext(SourcesContext);
	return sources;
}